import { c as _c } from "react/compiler-runtime";
import useTranslate from '@/contexts/i18nContext/hooks/useTranslate';
import { BTariffTypeEnum } from '@/types/backend';
import ExperienceExtra from './ExperienceExtra';
import ExperiencePrice from './ExperiencePrice';
const ExperiencePrices = (t0) => {
    const $ = _c(13);
    const { prices, extras } = t0;
    const translate = useTranslate();
    let t1;
    let t2;
    if ($[0] !== prices) {
        t2 = prices.reduce(_temp, false);
        $[0] = prices;
        $[1] = t2;
    }
    else {
        t2 = $[1];
    }
    t1 = t2;
    const hasSpecialTariffs = t1;
    let t3;
    if ($[2] !== hasSpecialTariffs || $[3] !== prices) {
        let t4;
        if ($[5] !== hasSpecialTariffs) {
            t4 = (p, i) => <ExperiencePrice key={`${i}-${p.nameFr}`} price={p} hasSpecialTariffs={hasSpecialTariffs}/>;
            $[5] = hasSpecialTariffs;
            $[6] = t4;
        }
        else {
            t4 = $[6];
        }
        t3 = prices.map(t4);
        $[2] = hasSpecialTariffs;
        $[3] = prices;
        $[4] = t3;
    }
    else {
        t3 = $[4];
    }
    let t4;
    if ($[7] !== extras || $[8] !== translate) {
        t4 = extras && extras.length ? <>

      <h3 className="my-2 font-semibold">{translate("practical.extras.title")}</h3>
      {extras.map(_temp2)}</> : null;
        $[7] = extras;
        $[8] = translate;
        $[9] = t4;
    }
    else {
        t4 = $[9];
    }
    let t5;
    if ($[10] !== t3 || $[11] !== t4) {
        t5 = <>{t3}{t4}</>;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    }
    else {
        t5 = $[12];
    }
    return t5;
};
export default ExperiencePrices;
function _temp(acc, tariff) { return acc || tariff.type === BTariffTypeEnum.Special; }
function _temp2(e, i_0) { return <ExperienceExtra key={`${i_0}-${e.nameFr}`} extra={e}/>; }
